// import { useRef } from "react";
// import "../Styles/Categories.css";

// const Categories = () => {
//   const scrollContainerRef = useRef(null);

//   const scrollLeft = () => {
//     if (scrollContainerRef.current) {
//       scrollContainerRef.current.scrollBy({ left: -400, behavior: "smooth" });
//     }
//   };

//   const scrollRight = () => {
//     if (scrollContainerRef.current) {
//       scrollContainerRef.current.scrollBy({ left: 400, behavior: "smooth" });
//     }
//   };

//   // Category data
//   const categories = [
//     {
//       id: 1,
//       title: "Herbicides",
//       icon: "🌿",
//       description:
//         "Weeds are unwanted plants. Herbicides kill or inhibit their growth. Unlike other pesticides, herbicides control plant growth instead of protecting them.",
//     },
//     {
//       id: 2,
//       title: "Fungicides",
//       icon: "🧫",
//       description:
//         "Fungi, bacteria, and viruses harm plants, causing mold, rot, and disease. Fungicides prevent and combat these issues, acting as protective measures.",
//     },
//     {
//       id: 3,
//       title: "Pesticides / Insecticides",
//       icon: "🐞",
//       description:
//         "Insecticides kill bugs, acaricides target mites, and rodenticides manage rodents. They all enhance agricultural productivity.",
//     },
//     {
//       id: 4,
//       title: "Fertilizer",
//       icon: "🌱",
//       description:
//         "Fertilizer enhances growth. Chemical types contain compounds, while biological ones contain living organisms.",
//     },
//     {
//       id: 5,
//       title: "Seeds",
//       icon: "🌾",
//       description:
//         "High-quality seeds are essential for successful crop production and higher yields in agricultural practices.",
//     },
//     {
//       id: 6,
//       title: "Equipment",
//       icon: "🚜",
//       description:
//         "Modern farming equipment increases efficiency and productivity in agricultural operations.",
//     },
//   ];

//   return (
//     <div className="categories-container">
//       <div className="categories-header">
//         <h1>Top Categories</h1>
//         <div className="navigation-buttons">
//           <button className="nav-button" onClick={scrollLeft}>
//             ←
//           </button>
//           <button className="nav-button" onClick={scrollRight}>
//             →
//           </button>
//         </div>
//       </div>

//       <div className="categories-scroll" ref={scrollContainerRef}>
//         {categories.map((category) => (
//           <div className="category-card" key={category.id}>
//             <div className="category-icon">{category.icon}</div>
//             <h2 className="category-title">{category.title}</h2>
//             <p className="category-description">{category.description}</p>
//             <button className="category-button">
//               <span className="arrow-icon">→</span>
//             </button>
//           </div>
//         ))}
//       </div>
//     </div>
//   );
// };

// export default Categories;

import { useRef } from "react";
import "../Styles/Categories.css";

const Categories = () => {
  const scrollContainerRef = useRef(null);

  const scrollLeft = () => {
    if (scrollContainerRef.current) {
      scrollContainerRef.current.scrollBy({ left: -400, behavior: "smooth" });
    }
  };

  const scrollRight = () => {
    if (scrollContainerRef.current) {
      scrollContainerRef.current.scrollBy({ left: 400, behavior: "smooth" });
    }
  };

  // Category data
  const categories = [
    { id: 1, title: "Herbicides", icon: "🌿", description: "Weeds are unwanted plants. Herbicides kill or inhibit their growth." },
    { id: 2, title: "Fungicides", icon: "🧫", description: "Fungi, bacteria, and viruses harm plants. Fungicides help prevent and combat them." },
    { id: 3, title: "Pesticides / Insecticides", icon: "🐞", description: "Insecticides, acaricides, and rodenticides help control pests and increase productivity." },
  ];

  return (
    <div className="categories-container">
      <div className="categories-header">
        <h1>Top Categories</h1>
        <div className="navigation-buttons">
          <button className="nav-button" onClick={scrollLeft}>←</button>
          <button className="nav-button" onClick={scrollRight}>→</button>
        </div>
      </div>

      <div className="categories-scroll" ref={scrollContainerRef}>
        {categories.map((category) => (
          <div className="category-card" key={category.id}>
            <div className="category-icon">{category.icon}</div>
            <h2 className="category-title">{category.title}</h2>
            <p className="category-description">{category.description}</p>
            <button className="category-button"><span className="arrow-icon">→</span></button>
          </div>
        ))}
      </div>
    </div>
  );
};

export default Categories;
